import { useRef } from "react";
import Translate from "./Translate";

const OtpCodeInputGroup = ({ value, onChange, isInvalid, invalidText }) => {
  // Modal-style rounded gradient border
  const clipPath = `
    before:content-['']
    before:absolute
    before:inset-0
    before:p-px
    before:rounded-lg
    before:[background:linear-gradient(90deg,rgba(196,39,224,1)_0%,rgba(132,74,255,1)_47%,rgba(18,169,255,1)_100%)]
    before:[-webkit-mask:linear-gradient(#fff_0_0)_content-box,linear-gradient(#fff_0_0)]
    before:[-webkit-mask-composite:xor]
    before:[mask-composite:exclude]
    before:z-10
    before:pointer-events-none
    bg-[#1A062A]
    rounded-lg
  `;

  const inputsRef = useRef([]);

  const handleChange = (e, index) => {
    const val = e.target.value;

    // Accept only digits, and only the first character
    if (!/^\d?$/.test(val)) {
      return;
    }

    const valueArray = value.split("");
    valueArray[index] = val;
    const newValue = valueArray.join("");

    onChange(newValue);

    if (val && index < 5) {
      inputsRef.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      if (value[index]) {
        const valueArray = value.split("");
        valueArray[index] = "";
        onChange(valueArray.join(""));
      } else if (index > 0) {
        inputsRef.current[index - 1]?.focus();
      }
    }
  };

  return (
    <div className="w-full">
      <div className="w-full flex items-center justify-between gap-2">
        {[...Array(6)].map((_, index) => (
          <div
            key={index}
            className={`relative xl:w-[60px] xl:h-[60px] lg:w-[60px] lg:h-[60px] w-[40px] h-[40px] ${clipPath} ${
              isInvalid ? "bg-red-600/50" : ""
            } rounded-lg`}
          >
            <div
              className={`absolute inset-[1px] rounded-lg ${
                isInvalid
                  ? "bg-red-600/50 bg-opacity-100"
                  : "bg-[#1C1C1C] bg-opacity-70 focus-within:bg-opacity-80"
              } transition-all duration-200`}
            >
              <input
                ref={(el) => (inputsRef.current[index] = el)}
                type="text"
                name={`otp-${index}`}
                maxLength={1}
                value={value[index] || ""}
                onChange={(e) => handleChange(e, index)}
                onKeyDown={(e) => handleKeyDown(e, index)}
                className="outline-none border-none w-full h-full bg-transparent text-center xl:text-2xl lg:text-2xl text-lg font-semibold text-white rounded-lg"
              />
            </div>
          </div>
        ))}
      </div>
      {isInvalid && invalidText && (
        <p className="text-red-500 text-sm mt-1 px-1">
          <Translate>{invalidText}</Translate>
        </p>
      )}
    </div>
  );
};

export default OtpCodeInputGroup;
